// import Box from react-three/drei
import {useRef} from 'react'
import {useFrame} from '@react-three/fiber'
import {RoundedBox, Plane, Text} from '@react-three/drei'
import {useState} from 'react'
import {Interactive, useInteraction} from '@react-three/xr'

export const Quizquestion = ({ questionProps, whoosh}) => {
    const initial_zpos = questionProps.zpos || -1
    const question_pos = [0, 1, 0]
    const gap = questionProps.gap || 0.25
    const x_left = -1 * 2 * gap
    const x_right = 1 * 2 * gap
    const y_top = 1 * gap
    const y_bottom = -0.4 + 1 * gap
    
    const [qscore, setQscore] = useState(0)

    const ref = useRef()
    useInteraction(ref, 'onHover', (event) => {whoosh.play()})

    useFrame((_, delta) => {
        ref.current.position.z += questionProps.speed * delta 

        // If qscore is not zero that means that the question has been answered
        if (qscore !== 0) {
            // We dont want negative scores. So we update the score only if the question is correctly answered. Else we retain the global score
            if (qscore > 0) {
                ref.current.userData.answered=true;
                ref.current.userData.correct=true;
            }
            else {
                ref.current.userData.answered=true;
                ref.current.userData.incorrect=true;
            }
            setQscore(0);
        }
        //ref.current.rotation.y += 0.5 * delta
    })

    return (
        
            <group ref={ref} position={[0, 0, initial_zpos]} onPointerDown={() => { whoosh.play() }}>
                <Question size={[1.5, 0.25]} position={question_pos} text={questionProps.question} />
                <OptionBox position={[x_left, y_top, 0]} text={questionProps.options[0]} answer={questionProps.answer} setQscore={setQscore} />
                <OptionBox position={[x_left, y_bottom, 0]} text={questionProps.options[1]} answer={questionProps.answer} setQscore={setQscore} />
                <OptionBox position={[x_right, y_top, 0]} text={questionProps.options[2]} answer={questionProps.answer} setQscore={setQscore} />
                <OptionBox position={[x_right, y_bottom, 0]} text={questionProps.options[3]} answer={questionProps.answer} setQscore={setQscore} />
            </group>
        
    );


}

const Question = ( {size, position, text}) => {
    return(
        <Plane
        material-color={"tomato"}
        args={size} // Width, height
        position={position} // 
        >
            <Text color="black" fontSize={0.2} position-z={0.01} >
             {text}
            </Text>
        </Plane>
    );
}

const OptionBox = ( meshProps) => {
    const disabledColor = "grey"
    const enabledColor = "#33ccff"
    const successColor = "#50ff50"
    const errorColor = "#ff5050"
    const cubesize = 0.25
    const amI = meshProps.text === meshProps.answer;
    const [clicked, setClicked] = useState(false)
    const [color, setColor] = useState(disabledColor)
    const [enabled, setEnabled] = useState(false)
    const ref = useRef()
    
   
    useFrame((_) => {
        if ((ref.current.parent.parent.position.z > 0) && enabled === false) {
            setEnabled(true);
            setColor(enabledColor);
        }
        if (clicked) {
            setClicked(false);
            if (amI) {
                setColor(successColor);
                meshProps.setQscore(1);
           
            }
            else {
                setColor(errorColor);
                meshProps.setQscore(-1);
            }
            
        }
        
    })
    
    return (
        <Interactive 
            onHover={(event) => {
                     setClicked(true)
                }
            }
        >

       <RoundedBox ref={ref}
            onPointerDown={() => {console.log('down'); setClicked(true);}}
            args={[cubesize, cubesize,cubesize]} // Width, height, depth. Default is [1, 1, 1]
            radius={0.02} // Radius of the rounded corners. Default is 0.05
            smoothness={4} // The number of curve segments. Default is 4
            creaseAngle={0.4} // Smooth normals everywhere except faces that meet at an angle greater than the crease angle
           // rotation={[0,(Math.random()-0.5)*0.5,(Math.random()-0.5)*0.5]} // Give boxes a random tilt along z-axis
            {...meshProps} // All THREE.Mesh props are valid
         >
            <meshBasicMaterial color={color} />
        

            <Text color={"black"} fontSize={0.1} position-z={cubesize/2+0.001} > 
             {meshProps.text}
            </Text>
        </RoundedBox>

     
        </Interactive>
        );

        

}


